import { APIPresentationAssetAttributes, ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { NewSlide } from 'presentationEditor/types';

export const addSlideToExistingPresentation = actionCreator<{
  presentation: APIPresentationAssetAttributes;
  newSlide: NewSlide;
}>('[presentationChooser] ADD_SLIDE_TO_EXISTING_PRESENTATION');

export const createPresentationAndAddSlide = actionCreator<{
  presentationName: string;
  folderId: ArdoqId | null;
  newSlide: NewSlide;
}>('[presentationChooser] CREATE_PRESENTATION_AND_ADD_SLIDE');

export const addSlideToNewOrExistingPresentation = actionCreator<NewSlide>(
  '[presentationChooser] ADD_SLIDE_TO_NEW_OR_EXISTING_PRESENTATION'
);
